module.exports = __webpack_public_path__ + "img/icon-gift-coupon-gray.cb97ab0e.svg";